import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Stats } from '../components/sections/Stats';
import { PainPoints } from '../components/sections/PainPoints';
import { Testimonials } from '../components/sections/Testimonials';
import { BonusOffer } from '../components/sections/BonusOffer';
import { Includes } from '../components/sections/Includes';
import { Pricing } from '../components/sections/Pricing';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { MetaPixel } from '../components/MetaPixel';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-brand-dark" data-id="element-233">
      <MetaPixel data-id="element-234" />
      <main data-id="element-235">
        <Hero data-id="element-236" />
        <Stats data-id="element-237" />
        <PainPoints data-id="element-238" />
        <Includes data-id="element-239" />
        <Testimonials data-id="element-240" />
        <BonusOffer data-id="element-241" />
        <Pricing data-id="element-242" />
        <FAQ data-id="element-243" />
        <FinalCTA data-id="element-244" />
      </main>
      <Footer data-id="element-245" />
      <SocialProofPopup data-id="element-246" />
    </div>;
}